export { QuickReplies, type QuickRepliesProps, type UIQuickReply } from "./QuickReplies"
